// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1sxum","footer":"ChangeClinic_footer__10bv6"};